// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1QeY3","name":"Header_name__1qDqc","birthday":"Header_birthday__2yjCb","skeleton":"Header_skeleton__3U-o1"};